import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import { parseHTML } from '../../utils/dom'
import Sidebar from '../sidebar/sidebar'

class PickupAvailability extends BaseComponent {
  connectedCallback(): void {
    this.fetchAvailability()
  }

  fetchAvailability(): void {
    const variantSectionUrl = `${this.dataset.baseUrl}variants/${this.dataset.variantId}/?section_id=pickup-availability`

    fetch(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const html = parseHTML(text).querySelector('.shopify-section')

        this.updateSidebarFromHTML(html)
        this.updateContentFromHTML(html)
      })
      .catch(() => {
        if (!bodyElement.notification) {
          return
        }

        bodyElement.notification.show(
          'Error in pickup availability component',
          'warning',
        )
      })
  }

  updateVariantId(newVariantId): void {
    this.dataset.variantId = newVariantId
  }

  updateContentFromHTML(html: Document): void {
    const content = this.querySelector('pickup-availability-content')
    const newContent = html.querySelector('pickup-availability-content')

    if (content && newContent) {
      const clonedNewContent = newContent.cloneNode(true)

      content.replaceChildren(...clonedNewContent.childNodes)
    }
  }

  updateSidebarFromHTML(html: Document): void {
    const drawer = document.getElementById(
      'pickup-availability-sidebar',
    ) as Sidebar

    if (!drawer) {
      return
    }

    const newTemplate = html.querySelector<HTMLTemplateElement>(
      `[data-sidebar-template="${drawer.id}"]`,
    )

    if (newTemplate) {
      drawer.updateTemplate(newTemplate)
    }
  }
}

export default PickupAvailability
